import { useAuth0 } from '@auth0/auth0-react';
import { getAuthErrorInfo, AuthErrorInfo } from '../helpers/auth_errors';
import { getDebugAuthError } from '../helpers/auth_debug';

/**
 * Single source of truth for "is Auth0 in an error state right now?".
 *
 * Used at the top of the app (`App.tsx`) to decide whether to render the
 * normal app shell (Sidebar + routes) or the full-page `AuthErrorScreen`
 * instead, and inside `PrivateRoute` as a defensive guard so it never
 * fires `loginWithRedirect()` while an error is present — that combination
 * is what causes an infinite redirect loop.
 */
export const useAuthErrorInfo = (): AuthErrorInfo | null => {
  const { error } = useAuth0();

  // getDebugAuthError() is a no-op outside development — see helpers/auth_debug.ts.
  return getAuthErrorInfo(getDebugAuthError() || error);
};

export default useAuthErrorInfo;
